import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-023e88c1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "input_box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "passwordEditPassword" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "xi-lock-o" })
], -1))
const _hoisted_3 = ["disabled"]
const _hoisted_4 = {
  key: 0,
  class: "error_message"
}
const _hoisted_5 = { class: "input_box" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "passwordEditNewPassword" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "xi-lock" })
], -1))
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 1,
  class: "error_message"
}
const _hoisted_9 = { class: "input_box" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "passwordEditConfirmPassword" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "xi-lock-o" })
], -1))
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 2,
  class: "error_message"
}
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "xi-angle-left" }, null, -1))

import { storeToRefs } from 'pinia';

import useCommonStore from '@/store/storeCommon';
import useMemberStore from '@/store/storeMember';


export default /*#__PURE__*/_defineComponent({
  __name: 'EditPassword',
  setup(__props) {

const { isLoading, isMainLogo, isSatelliteInfo } = storeToRefs(useCommonStore());
const { inputValueAni, disabledQualification, showPanel, showModal, modalContents } = useCommonStore();
const { confirmEditPassword } = storeToRefs(useMemberStore());
const { accessEditPassword, errorMessage, editPasswordForm, getLevelName } = useMemberStore();

const accessToken = localStorage.getItem('accessToken') || sessionStorage.getItem('accessToken');

/**
 * 수정한 nickname을 저장합니다.
 */
const submitEditPassword = async (): Promise<void> => {
  try {
    isLoading.value = true;

    const response = await accessEditPassword(editPasswordForm, accessToken);

    if (response) {
      showModal.isSuccess = true;
      confirmEditPassword.value = '';

      isMainLogo.value = true;
      isSatelliteInfo.value = false;
      Object.assign(editPasswordForm, {
        current: '',
        renew: '',
      });
      Object.assign(errorMessage, {
        currentPassword: '',
        newPassword: '',
        confirmNewPassword: '',
      });
      Object.assign(modalContents, {
        title: 'Welcome!',
        description: '비밀번호 변경이 성공하였습니다.',
      });
    }
  } catch (e) {
    console.log(e);
  } finally {
    isLoading.value = false;
  }
};

/**
 *  blur 시, 새로 입력한 비밀번호를 확인하고 에러 메세지를 표시합니다.
 */
const errorEditPasswordVerification = (): void => {
  if (editPasswordForm.renew !== confirmEditPassword.value) {
    errorMessage.confirmNewPassword = '비밀번호가 다릅니다.';
  }
  if (!confirmEditPassword.value) {
    errorMessage.confirmNewPassword = '';
  }
  if ((editPasswordForm.current === editPasswordForm.renew) && editPasswordForm.renew) {
    errorMessage.newPassword = '현재 비밀번호와 같습니다.';
  }
};

/**
 *  계정정보 페이지로 이동합니다.
 */
const closeEditPassword = (): void => {
  showPanel.isEditPassword = false;
  confirmEditPassword.value = '';
  Object.assign(editPasswordForm, {
    current: '',
    renew: '',
  });
  Object.assign(errorMessage, {
    currentPassword: '',
    newPassword: '',
    confirmNewPassword: '',
  });
};

/**
 * 조건별 함수
 */
const qualificationFunction = (qualification: string): boolean => {
  switch (qualification) {
    case 'showCurrentErrorMessage':
      return !!(errorMessage.currentPassword && editPasswordForm.current);
    case 'showNewErrorMessage':
      return !!(errorMessage.newPassword && (editPasswordForm.current === editPasswordForm.renew));
    case 'showConfirmErrorMessage':
      return !!(errorMessage.confirmNewPassword && (editPasswordForm.renew !== confirmEditPassword.value));
    case 'disabledEditPassword':
      return disabledQualification() || !(editPasswordForm.current && editPasswordForm.renew) || editPasswordForm.renew !== confirmEditPassword.value || editPasswordForm.current === editPasswordForm.renew;
    default:
      return false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["password_edit", _unref(getLevelName)()])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _withDirectives(_createElementVNode("input", {
        id: "passwordEditPassword",
        type: "password",
        placeholder: "PASSWORD",
        disabled: _unref(disabledQualification)(),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(editPasswordForm).current) = $event)),
        onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(inputValueAni) && _unref(inputValueAni)(...args)))
      }, null, 40, _hoisted_3), [
        [_vModelText, _unref(editPasswordForm).current]
      ])
    ]),
    (qualificationFunction('showCurrentErrorMessage'))
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(errorMessage).currentPassword), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _withDirectives(_createElementVNode("input", {
        id: "passwordEditNewPassword",
        type: "password",
        placeholder: "NEW PASSWORD",
        disabled: _unref(disabledQualification)(),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(editPasswordForm).renew) = $event)),
        onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(inputValueAni) && _unref(inputValueAni)(...args))),
        onBlur: errorEditPasswordVerification
      }, null, 40, _hoisted_7), [
        [_vModelText, _unref(editPasswordForm).renew]
      ])
    ]),
    (qualificationFunction('showNewErrorMessage'))
      ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(qualificationFunction("showNewErrorMessage") ? _unref(errorMessage).newPassword : ""), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _withDirectives(_createElementVNode("input", {
        id: "passwordEditConfirmPassword",
        type: "password",
        placeholder: "CONFIRM NEW PASSWORD",
        disabled: _unref(disabledQualification)(),
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(confirmEditPassword) ? (confirmEditPassword).value = $event : null)),
        onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_unref(inputValueAni) && _unref(inputValueAni)(...args))),
        onBlur: errorEditPasswordVerification
      }, null, 40, _hoisted_11), [
        [_vModelText, _unref(confirmEditPassword)]
      ])
    ]),
    (qualificationFunction('showConfirmErrorMessage'))
      ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(qualificationFunction("showConfirmErrorMessage") ? _unref(errorMessage).confirmNewPassword : ""), 1))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["password_edit_submit_btn", { opacity : _unref(showModal).isSuccess }]),
      disabled: qualificationFunction('disabledEditPassword'),
      onClick: submitEditPassword
    }, " Edit ", 10, _hoisted_13),
    _createElementVNode("button", {
      type: "button",
      class: "password_edit_cancel_btn",
      disabled: _unref(disabledQualification)(),
      onClick: closeEditPassword
    }, [
      _hoisted_15,
      _createTextVNode(" Cancel ")
    ], 8, _hoisted_14)
  ], 2))
}
}

})